module.exports = __webpack_public_path__ + "img/logo.27b736f8.svg";